<template>
  <div class="right-fix pc" :class="'active' + active">
    <!-- <h2><img src="https://static.worldaic.com.cn/2024/web/static/images/waic5.png" alt=""></h2> -->
    <ul @mouseleave="active = -1">
      <li v-for="(item, index) in data" :key="index" @mouseenter="mouseenter(index)">
        <big @click="open(item.src, item.name)">{{ $t(item.name) }}</big>
        <div class="small">
          <span v-for="(ite, ind) in item.children" :key="ind" @click="ite.src && ite.src.includes('http') ? open(ite.src, item.name, index, ite.name, ind) : routerPoint('/' + ite.src, item.name, index, ite.name, ind)">
            {{ $t(ite.name) }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'right-fix',
  data() {
    return {
      data: [
        {
          "name": "fixRight1",
          "src": "https://online2025.worldaic.com.cn/home?channelSource=Web"
        },
        {
          "name": "fixRight2",
          "children": [
            {
              "name": "fixRight3",
              "src": "apply"
            },
            {
              "name": "fixRight4",
              "src": ""
            },
            {
              "name": "fixRight5",
              "src": "https://online2025.worldaic.com.cn/home?channelSource=Web"
            },
          ]
        },
        {
          "name": "dahuifuwu",
          "children": [
            {
              "name": "submission",
              "src": "https://sail.worldaic.com.cn/login"
            },
            {
              "name": "venueGuide",
              "src": "fuwu#q0"
            },
            {
              "name": "canhuizhinan",
              "src": "fuwu#q1"
            },
            {
              "name": "download",
              "src": "fuwu#q2"
            },
            {
              "name": "problem",
              "src": "fuwu#q3"
            },
            {
              "name": "contact",
              "src": "fuwu#q4"
            },
          ]
        },
        {
          "name": "WAIC UP!",
          "src": "https://up.worldaic.com.cn"
        },
      ],
      active: -1
    }
  },
  methods: {
    open(src, first, index, sec, ind) {
      this.$jsAPI('track','sideFirstNavigation',
          {
            'firstNavigation_var': this.$ch(first),
            'secondNavigation_var': this.$ch(sec),
          }
      );
      gio('track','sideFirstNavigation',
          {
            'firstNavigation_var': this.$t(first),
            'secondNavigation_var': this.$ch(sec),
          }
      );
      console.log({
            'firstNavigation_var': this.$ch(first),
            'secondNavigation_var': this.$ch(sec),
          })
      if (!src) return
      window.open(src, '_blank')
    },
    routerPoint(path, first, index, sec, ind) {
      if (path === '/') {
        this.$jsAPI('track','sideSecNavigation',
            {
              'firstNavigation_var': this.$ch(first),
              'position_var': `${index + 1}-${ind + 1}`,
              'secondNavigation_var': this.$ch(sec),
            }
        );
        gio('track','sideSecNavigation',
            {
              'firstNavigation_var': this.$t(first),
              'position_var': `${index + 1}-${ind + 1}`,
              'secondNavigation_var': this.$t(sec),
            }
        );
        console.log('sideSecNavigation', {
              'firstNavigation_var': this.$ch(first),
              'position_var': `${index + 1}-${ind + 1}`,
              'secondNavigation_var': this.$ch(sec),
            })
        window.open('https://reg.worldaic.com.cn', '_blank')
        return
      }
      this.$jsAPI('track','sideSecNavigation',
          {
            'firstNavigation_var': this.$ch(first),
            'position_var': `${index + 1}-${ind + 1}`,
            'secondNavigation_var': this.$ch(sec),
          }
      );
      gio('track','sideSecNavigation',
          {
            'firstNavigation_var': this.$t(first),
            'position_var': `${index + 1}-${ind + 1}`,
            'secondNavigation_var': this.$t(sec),
          }
      );
      console.log('sideSecNavigation', {
            'firstNavigation_var': this.$ch(first),
            'position_var': `${index + 1}-${ind + 1}`,
            'secondNavigation_var': this.$ch(sec),
          })
      this.$router.push(path);
      this.scrollTo();
    },
    mouseenter(index) {
      this.active = index
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .right-fix {
    position: fixed;
    right: .25rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    padding: .5rem .2rem .5rem 0;

    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: .02rem;
      height: 1rem;
      background-image: url(https://static.worldaic.com.cn/2024/web/static/images/top-line.png);
      background-size: 100% 100%;
      transition: .5s;
    }

    &::after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: .02rem;
      height: 1rem;
      background-image: url(https://static.worldaic.com.cn/2024/web/static/images/bottom-line.png);
      background-size: 100% 100%;
      transition: .5s;
    }

    &.active-1 {
      &::before {
        height: 1.75rem;
      }

      &::after {
        height: 1.75rem;
      }
    }

    &.active0 {
      &::before {
        height: 0.9rem;
      }

      &::after {
        height: 2.32rem;
      }
    }

    &.active1 {
      &::before {
        height: 1.5rem;
      }

      &::after {
        height: 2.92rem;
      }
    }

    &.active2 {
      &::before {
        height: 2.1rem;
      }

      &::after {
        height: 3.46rem;
      }
    }

    &.active3 {
      &::before {
        height: 2.72rem;
      }

      &::after {
        height: 0.48rem;
      }
    }

    h2 {
      font-size: .26rem;
      font-weight: bold;
      color: #2960FF;
      line-height: 1;
      position: relative;

      img {
        position: absolute;
        right: -0.2rem;
        bottom: 0;
        width: .83rem;
        height: .84rem;
      }
    }

    ul {

      li {
        margin-top: .4rem;

        big {
          display: block;
          text-align: right;
          cursor: pointer;
          font-size: .22rem;
          color: #284599;
          line-height: 1;
        }

        &:first-child big {
          font-size: .26rem;
          line-height: .22rem;
          font-weight: bold;
        }

        .small {
          height: 0;
          transition: 1s;
          overflow: hidden;
        }

        span {
          display: block;
          text-align: right;
          margin-top: .2rem;
          cursor: pointer;
          font-size: .18rem;
          color: #284599;
          line-height: .2rem;
          position: relative;
        }

        &:hover {

          big {
            color: #0361FF;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: -0.25rem;
              width: .12rem;
              height: .12rem;
              border-radius: 50%;
              background: RGBA(47, 159, 250, 1);
            }
          }

          &:nth-child(2) .small {
            height: 1.2rem;
          }

          &:nth-child(3) .small {
            height: 2.4rem;
          }

          span {
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: -0.28rem;
              width: .06rem;
              height: .06rem;
              border-radius: 50%;
              background: RGBA(47, 159, 250, 1);
            }
            
            &:hover {
              color: #0361FF;
            }
          }
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  
}
</style>



// WEBPACK FOOTER //
// src/components/rightFix.vue